import { handleAjaxError } from "./handleAjaxError";
import { clearGuestLocalHistory } from "../helpers/guestLocalHistory";
import { getLoaderDelayMs } from "../helpers/frontendDelays";
import {
    hideChatGlobalLoader,
    showChatGlobalLoader,
} from "../components/chatGlobalLoader";

/**
 * @param action
 */
export function clearSession(action) {
    const handler = function (event) {
        event.preventDefault();

        let submitBtn = $(this);
        let chatForm = submitBtn.closest('.g-chatform');
        let sessionToken = chatForm.attr('data-session-token');

        if (submitBtn.hasClass('is-loading') || submitBtn.hasClass('is-disabled')) {
            return;
        }

        if (!confirm('Are you sure you want to clear this entire session? All messages and settings in this session will be permanently removed.')) {
            return;
        }

        submitBtn.addClass('is-loading');
        showChatGlobalLoader(chatForm, {
            text: 'Restarting',
        });

        const loaderStartedAt = Date.now();
        const minimumLoaderDuration = getLoaderDelayMs(chatForm, 'default', 'text');

        const redirectWithVisibleLoader = (targetUrl) => {
            const elapsed = Date.now() - loaderStartedAt;
            const remainingDelay = Math.max(0, minimumLoaderDuration - elapsed);

            setTimeout(() => {
                window.location.href = targetUrl;
            }, remainingDelay);
        };

        jQuery.ajax({
            url: growtype_chat_ajax.url,
            type: 'post',
            data: {
                session_token: sessionToken,
                action: growtype_chat_ajax.session_clear_messages_action,
                nonce: growtype_chat_ajax.nonce,
            },
            success: function (response) {
                if (response.success) {
                    clearGuestLocalHistory(chatForm);
                    const reloadUrl = response?.data?.reload_url || window.location.href;
                    redirectWithVisibleLoader(reloadUrl);
                } else {
                    alert(response.data.message || 'Error clearing session');
                    submitBtn.removeClass('is-loading');
                    hideChatGlobalLoader(chatForm);
                }
            },
            error: function (response) {
                hideChatGlobalLoader(chatForm);
                handleAjaxError(response, submitBtn);
            }
        });
    };

    if (typeof action.off === 'function' && typeof action.on === 'function') {
        action
            .off('click.growtypeClearSession')
            .on('click.growtypeClearSession', handler);
    } else {
        action.click(handler);
    }
}
